export default __webpack_public_path__ + "static/media/Airplane.965bbff0.svg";